// START IMPORTS
import { Divider, Text, Stack } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
// END IMPORTS

// START INTERFACES_AND_TYPES
interface DescriptionDatesProps {
  isOnDashboard: boolean;
  updatedDate: string;
  createdDate: string;
  lastViewedDate: string;
}
// END INTERFACES_AND_TYPES

export const DescriptionDates = ({
  isOnDashboard,
  updatedDate,
  createdDate,
  lastViewedDate,
}: DescriptionDatesProps) => {
  // START HOOKS_AND_QUERIES
  const { isMobile } = useScreenSize();
  // END HOOKS_AND_QUERIES

  // START DERIVED_DATA_AND_UTILS
  const textVariant = isMobile ? 'body2' : undefined;
  // END DERIVED_DATA_AND_UTILS

  // START EARLY_RETURNS
  if (isOnDashboard) {
    return (
      <Stack direction="column" spacing={1}>
        <Stack direction="row" spacing={1}>
          <Text variant={textVariant}>Updated {updatedDate}</Text>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'text.secondary' }}
          />
        </Stack>
        <Stack direction="row" spacing={1}>
          <Text variant={textVariant}>Created {createdDate}</Text>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'text.secondary' }}
          />
        </Stack>
        <Text variant={textVariant}>Viewed {lastViewedDate}</Text>
      </Stack>
    );
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <Stack direction="row" spacing={1}>
      <Text variant={textVariant}>Updated {updatedDate}</Text>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ borderColor: 'text.secondary' }}
      />
      <Text variant={textVariant}>Created {createdDate}</Text>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ borderColor: 'text.secondary' }}
      />
      <Text variant={textVariant}>Viewed {lastViewedDate}</Text>
    </Stack>
  );
  // END RENDER
};
